import _styled from '@emotion/styled/base';
import { spacing } from '@hubble/tokens/web';
import { Flex } from '../Flex/index.js';

const EmptyStateWrapper = _styled(Flex, {
  target: "e1vtjxdy1"
})("min-height:256px;min-width:256px;width:100%;gap:", spacing[16], ";flex-direction:column;align-items:center;justify-content:center;padding:", spacing[32], " ", spacing[48], ";box-sizing:border-box;text-align:center;");
const EmptyStateTextWrapper = _styled(Flex, {
  target: "e1vtjxdy0"
})({
  name: "dc5hdu",
  styles: "flex-direction:column;align-items:center;text-align:center"
} );

export { EmptyStateTextWrapper, EmptyStateWrapper };
